// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27%3E%3Ccircle cx=%277%27 cy=%277%27 r=%275%27 fill=%27none%27 stroke=%27%238d8d8d%27 stroke-width=%271.5%27/%3E%3Cpath d=%27M10.8 10.8L14 14%27 stroke=%27%238d8d8d%27 stroke-width=%271.5%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27%3E%3Cpath d=%27M0 0l5 6 5-6z%27 fill=%27%23525252%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/service-booking-widget-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-top: #f8fafc;
  --bg-bottom: #e4ebf5;
  --table-border: #b2b2b2;
  --header-bg: #f0f0f0;
  --row-even: #fafafa;
  --row-odd: #ffffff;
  --text-default: #4d4d4d;
  --link-blue: #0559bf;

  color: var(--text-default);
  font-family: 'Avenir Next', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 400;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Null/empty cell dash indicator — scoped to avoid UCL conflicts */
.shvev-null-dash {
  font-size: 1.2em;
  font-weight: 700;
  letter-spacing: 0.05em;
}

* {
  box-sizing: border-box;
}

body,
button,
input,
textarea,
select {
  font: inherit;
}

.app-components {
  padding: 20px;
}

.component-section {
  margin-bottom: 32px;
}

.analysis-shell {
  width: min(760px, calc(100% - 2.5rem));
  margin: 0 auto;
  padding: 3.25rem 0;
}

.analysis-table-card {
  border: 1px solid var(--table-border);
  border-radius: 8px;
  overflow-x: auto;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(12, 25, 43, 0.1);
}

.analysis-table {
  width: 100%;
  min-width: 660px;
  border-collapse: separate;
  border-spacing: 0;
}

.analysis-table th,
.analysis-table td {
  height: 40px;
  padding: 4px 12px;
  border-bottom: 1px solid var(--table-border);
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  color: var(--text-default);
}

.analysis-table thead th {
  background: var(--header-bg);
  font-weight: 500;
}

.analysis-table tbody tr:nth-child(odd) td {
  background: var(--row-odd);
}

.analysis-table tbody tr:nth-child(even) td {
  background: var(--row-even);
}

.analysis-table tbody tr:last-child td {
  border-bottom: 0;
}

.analysis-table a {
  color: var(--link-blue);
  text-decoration: none;
  font-weight: 500;
}

.analysis-table a:hover,
.analysis-table a:focus-visible {
  text-decoration: underline;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 760px) {
  .analysis-shell {
    width: min(100% - 1rem, 760px);
    padding: 1rem 0 1.5rem;
  }

  .analysis-table-card {
    border: 0;
    box-shadow: none;
    background: transparent;
    overflow: visible;
  }

  .analysis-table {
    min-width: 100%;
    border-spacing: 0 0.75rem;
  }

  .analysis-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .analysis-table tbody tr {
    display: block;
    border: 1px solid var(--table-border);
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;
  }

  .analysis-table tbody td {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;
    height: auto;
    border-bottom: 1px solid #dddddd;
    padding: 0.7rem 0.9rem;
    background: #ffffff;
  }

  .analysis-table tbody td:last-child {
    border-bottom: 0;
  }

  .analysis-table tbody td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #404040;
  }
}

.shvtv-root {
  padding-top: 14px;
  padding-bottom: 10px;
  background: #ececec;
}

.shvtv-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 12px;
  margin-bottom: 12px;
}

.shvtv-title {
  margin: 0;
  color: #161616;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 600;
  letter-spacing: 0;
  white-space: nowrap;
}

.shvtv-header a {
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  color: #0559bf;
  font-size: 19px;
  line-height: 1;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.shvtv-header a:hover,
.shvtv-header a:focus-visible {
  text-decoration: underline;
}

.shvtv-table-shell {
  border: 1px solid #b2b2b2;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
}

.shvtv-table {
  width: 100%;
  border-collapse: collapse;
}

.shvtv-head-cell {
  padding: 12px 10px;
  background: #fafafb !important;
  border-bottom: 1px solid #e0e0e0;
  color: #4f4f4f;
  text-align: left;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
  white-space: nowrap;
}

.shvtv-body-cell {
  padding: 10px;
  color: #595959;
  font-size: 15px;
  line-height: 1.25;
  font-weight: 400;
}

.shvtv-row-even {
  background: #ececec !important;
}

.shvtv-row-odd {
  background: #f6f6f6 !important;
}

.shvtv-service-link-cell a {
  color: #0559bf;
  text-decoration: none;
  font-size: 15px;
  line-height: 1.25;
  font-weight: 500;
}

.shvtv-service-link-cell a:hover,
.shvtv-service-link-cell a:focus-visible {
  text-decoration: underline;
}

@media (max-width: 760px) {
  .shvtv-root {
    max-width: 100%;
    padding: 10px;
  }

  .shvtv-title {
    font-size: 24px;
  }

  .shvtv-header a {
    font-size: 20px;
  }

  .shvtv-head-cell,
  .shvtv-body-cell,
  .shvtv-service-link-cell a {
    font-size: 16px;
    line-height: 1.35;
  }

  .shvtv-head-cell,
  .shvtv-body-cell {
    padding: 10px 8px;
  }
}

.shvev-root {
  padding: 0;
  background: #ffffff;
  color: #595959;
}

.shvev-title {
  margin: 0 0 16px;
  color: #161616;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 600;
}

.shvev-controls {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
}

.shvev-fleet-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  background: #eaf4ff;
  color: #0559bf;
  padding: 12px 16px;
  font-size: 15px;
  line-height: 1.4;
}

.shvev-fleet-alert-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0559bf;
  flex-shrink: 0;
}

.shvev-controls-top {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
}

.shvev-controls-top--left {
  justify-content: flex-start;
}

.shvev-control-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.shvev-control-search {
  flex: 0 1 360px;
  min-width: 260px;
  max-width: none;
}

.shvev-control-category {
  width: fit-content;
  min-width: 150px;
}

.shvev-category-dropdown {
  position: relative;
}

.shvev-category-trigger {
  min-height: 32px;
  border-radius: 8px !important;
  border: 1px solid #767676 !important;
  padding: 4px 10px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  cursor: pointer !important;
}

.shvev-category-trigger.shvev-category-trigger {
  color: #595959;
}

.shvev-category-label {
  color: #595959;
}

.shvev-category-trigger:focus {
  outline: none;
  border-color: #0f62fe;
  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);
}

.shvev-category-count {
  min-width: 16px;
  height: 16px;
  border-radius: 999px;
  background: #0f62fe;
  color: #ffffff;
  font-size: 11px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.shvev-category-chevron {
  display: inline-flex;
  align-items: center;
  color: #0f62fe;
  transition: transform 0.15s ease;
}

.shvev-category-chevron.open {
  transform: rotate(180deg);
}

.shvev-category-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 260px;
  border: 1px solid #c6c6c6;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14);
  z-index: 50;
}

.shvev-category-search-wrap {
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.shvev-category-search {
  width: 100%;
  height: 36px;
  border: 1px solid #c6c6c6;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 13px;
  color: #3d3d3d;
}

.shvev-category-search:focus {
  outline: none;
  border-color: #0f62fe;
  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);
}

.shvev-category-options {
  max-height: 320px;
  overflow-y: auto;
  padding: 8px 10px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.shvev-category-option input[type='checkbox'] {
  width: 18px;
  height: 18px;
  margin-top: 1px;
  accent-color: #0f62fe;
  cursor: pointer;
  flex-shrink: 0;
}

.shvev-category-no-results {
  margin: 12px 0;
  text-align: center;
  color: #525252;
  font-size: 15px;
}

.shvev-clear-input-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #6f6f6f;
  cursor: pointer;
  padding: 0;
}

.shvev-clear-input-btn:hover {
  background: #eef2f7;
  color: #3d3d3d;
}

.shvev-clear-input-btn:focus-visible {
  outline: 2px solid #0f62fe;
  outline-offset: 1px;
}

.shvev-control-label {
  font-size: 13px;
  line-height: 1.2;
  font-weight: 500;
  color: #595959;
}

.shvev-search-wrapper {
  position: relative;
}

.shvev-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
}

.shvev-select,
.shvev-search {
  height: 32px;
  border: 1px solid #b8b8b8;
  border-radius: 8px;
  padding: 0 10px;
  background: #ffffff;
  font-size: 15px;
  line-height: 1.25;
  color: #595959;
}

.shvev-search {
  width: 100%;
  padding-left: 36px;
}

.shvev-select {
  min-width: 130px;
  padding-right: 28px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.shvev-select:focus,
.shvev-search:focus {
  outline: none;
  border-color: #0f62fe;
  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);
}

.shvev-download-btn,
.shvev-download-btn:not([class*='Button']) {
  height: 36px;
  border: 1.5px solid #0f62fe;
  border-radius: 8px !important;
  background: #ffffff;
  color: #0559bf;
  padding: 0 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  margin-left: auto;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.shvev-download-btn:hover {
  background: #edf4ff;
  border-color: #0559bf;
}

.shvev-download-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.3);
}

.shvev-download-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.shvev-download-btn-loading,
.shvev-download-btn-loading:hover,
.shvev-download-btn-loading:focus {
  background-color: #8d8d8d !important;
  border-color: #8d8d8d !important;
  color: #ffffff !important;
  cursor: not-allowed !important;
}

.shvev-snackbar-wrapper {
  display: flex;
  justify-content: center;
  margin: 8px 0 4px;
}

/* Custom toast — matches @ucl/fpds Snackbar design tokens exactly */
.shvev-toast {
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 8px;
  padding-block: 8px;
  padding-inline: 16px;
  padding-inline-end: 8px;
  border-radius: 8px;
  margin-top: 16px;
  min-height: 48px;
  box-sizing: border-box;
  color: #ffffff;
  background-color: #001025;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0;
  pointer-events: all;
  flex-shrink: 0;
  flex-grow: 0;
  animation: shvev-toast-open 0.3s ease-in-out;
}

@keyframes shvev-toast-open {
  from { opacity: 0; transform: translateY(100%); }
  to   { opacity: 1; transform: translateY(0); }
}

.shvev-toast--success,
.shvev-toast--primary {
  background-color: #001025;
}

.shvev-toast--error {
  background-color: #d62d0a;
}

.shvev-toast-message {
  padding: 4px;
  padding-inline-end: 12px;
  box-sizing: border-box;
  min-height: 32px;
  display: flex;
  align-items: center;
}

.shvev-toast-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 2px 4px;
  opacity: 0.8;
  flex-shrink: 0;
  height: 32px;
  width: 32px;
  border-radius: 8px;
}

.shvev-toast-close:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.15);
}

.shvev-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 72px;
  width: 100%;
}

.shvev-service-link {
  color: #0559bf;
  font-size: 15px;
  line-height: 1.25;
  font-weight: 500;
  display: inline-block;
  text-decoration: none;
}

.shvev-service-link:hover,
.shvev-service-link:focus-visible {
  text-decoration: underline;
}

.shvev-vehicle-cell {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.shvev-vehicle-name {
  font-size: 14px;
  font-weight: 600;
  color: #161616;
  line-height: 1.3;
}

.shvev-vehicle-vin {
  font-size: 13px;
  color: #6f6f6f;
  line-height: 1.3;
}

a.shvev-vehicle-vin {
  color: #0559bf;
  text-decoration: none;
}

a.shvev-vehicle-vin:hover,
a.shvev-vehicle-vin:focus-visible {
  text-decoration: underline;
}

.shvev-vehicle-vin-row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.shvev-redirect-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #0559bf;
  padding: 0;
  cursor: pointer;
}

.shvev-redirect-icon-btn:hover {
  color: #0559bf;
}

.shvev-redirect-icon-btn:focus-visible {
  outline: 2px solid #0f62fe;
  outline-offset: 2px;
  border-radius: 3px;
}

.shvev-vin-subtext {
  display: block;
  margin-top: 4px;
  color: #595959;
  font-size: 12px;
}

.shvev-source-subtext {
  display: block;
  margin-top: 4px;
  color: #595959;
  font-size: 15px;
  line-height: 1.25;
  font-weight: 400;
}

.shvev-table-shell {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: auto;
  background: #ffffff;
}

.shvev-table {
  width: 100%;
  min-width: 1240px;
  border-collapse: collapse;
}

.shvev-table th {
  padding: 12px 16px;
  text-align: left !important;
  background: #fafafb !important;
  border-bottom: 1px solid #e0e0e0;
  color: #595959 !important;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 400 !important;
}

.shvev-table .TableHeader {
  padding: 12px 16px !important;
  background: #fafafb !important;
  border-bottom: 1px solid #e0e0e0 !important;
  color: #595959 !important;
  font-size: 16px !important;
  line-height: 1.2 !important;
  font-weight: 400 !important;
}

.shvev-th-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  color: #595959 !important;
  font: inherit;
  font-size: 16px !important;
  font-weight: 400 !important;
  padding: 0;
  cursor: pointer;
  text-align: left !important;
  justify-content: flex-start !important;
}

.shvev-table th button.shvev-th-button,
.shvev-table .TableHeader button.shvev-th-button {
  justify-content: flex-start !important;
  text-align: left !important;
  width: 100% !important;
  padding: 0 !important;
}

.shvev-table th button.shvev-th-button:hover,
.shvev-table th button.shvev-th-button:active,
.shvev-table .TableHeader button.shvev-th-button:hover,
.shvev-table .TableHeader button.shvev-th-button:active {
  background: transparent !important;
  box-shadow: none !important;
}

.shvev-th-button:focus-visible {
  outline: 2px solid #0f62fe;
  outline-offset: 2px;
  background: transparent !important;
  box-shadow: none !important;
}

.shvev-sort-icon {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  color: #595959;
  line-height: 1;
}

.shvev-sort-tri {
  font-size: 10px;
  line-height: 1;
}

.shvev-sort-icon--active {
  display: inline-flex;
  align-items: center;
  color: #595959;
  font-size: 11px;
  line-height: 1;
}


.shvev-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e8e8e8;
  color: #595959;
  font-size: 15px;
  line-height: 1.25;
  font-weight: 400;
  text-align: left !important;
  vertical-align: top;
}

.shvev-table tbody tr:hover {
  background: #f9f9f9;
}

.shvev-table tbody tr:nth-child(odd) {
  background: #ffffff;
}

.shvev-table tbody tr:nth-child(even) {
  background: #f9f9f9;
}

.shvev-empty {
  margin: 16px;
  padding: 12px;
  text-align: center;
  color: #595959;
  font-size: 15px;
}

.shvev-no-results {
  margin: 24px 0 12px;
  text-align: center;
  color: #000000;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 700;
}

.shvev-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #e0e0e0;
  background: #f9f9f9;
  font-size: 13px;
  gap: 16px;
}

.shvev-pagination-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}

.shvev-pagination-left .Pagination_TextWrapper {
  display: none !important;
}

.shvev-pagination .Pagination_TextWrapper {
  display: none !important;
}

.shvev-pagination [aria-live='polite'] {
  display: none !important;
}

.shvev-pagination-left nav {
  display: none;
}

.shvev-rows-per-page {
  height: 32px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 0 28px 0 10px;
  background: #ffffff;
  font-size: 13px;
  color: #525252;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 10px center;
}

.shvev-rows-per-page:focus {
  outline: none;
  border-color: #0f62fe;
  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);
}

.shvev-pagination-total {
  color: #595959;
  white-space: nowrap;
  font-weight: 600;
  font-size: 15px;
  line-height: 1.4;
}

.shvev-pagination-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.shvev-pagination-btn {
  height: 32px;
  width: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #0559bf;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.shvev-pagination-arrow {
  font-size: 20px;
  line-height: 1;
}

.shvev-pagination-btn:hover:not(:disabled) {
  background: #dde8ff;
}

.shvev-pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: #a8a8a8;
}

.shvev-pagination-btn.active {
  background: #0559bf;
  color: #ffffff;
}

.shvev-pagination-btn.active:hover {
  background: #0559bf;
}

.shvev-pagination-ellipsis {
  color: #8d8d8d;
  padding: 0 6px;
  font-size: 14px;
}

@media (max-width: 768px) {
  .shvev-pagination {
    flex-direction: column;
    align-items: flex-start;
  }

  .shvev-pagination-left,
  .shvev-pagination-controls {
    width: 100%;
  }

  .shvev-pagination-controls {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

/* Mobile download button hidden on desktop */
.shvev-download-btn--mobile {
  display: none !important;
}

@media (max-width: 768px) {
  /* Uniform gap between controls */
  .shvev-controls {
    gap: 12px;
  }

  /* Search stretches to full width */
  .shvev-control-search {
    flex: 1;
    min-width: unset;
    max-width: unset;
  }

  /* Category full width */
  .shvev-control-category {
    width: 100%;
  }

  /* Hide the desktop download button (inside controls-top) — fleet view only */
  .shvev-controls-top:not(.shvev-controls-top--left) .shvev-download-btn {
    display: none !important;
  }

  /* Show and expand the mobile download button */
  .shvev-download-btn--mobile {
    display: inline-flex !important;
    width: 100%;
    justify-content: center;
    margin-left: 0;
  }
}

@media (max-width: 1100px) {
  .shvev-controls-top {
    align-items: center;
  }

  .shvev-control-search {
    flex: 0 1 320px;
    min-width: 240px;
  }

  .shvev-download-btn {
    width: auto;
  }
}

/* Export modal */
.shvev-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.shvev-modal {
  background: #ffffff;
  border-radius: 12px;
  width: 640px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
}

.shvev-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 28px 0 28px;
}

.shvev-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #161616;
  margin: 0;
}

.shvev-modal-close {
  border: none;
  background: transparent;
  font-size: 18px;
  color: #595959;
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;
  border-radius: 4px;
}

.shvev-modal-close:hover {
  background: #f4f4f4;
  color: #161616;
}

.shvev-modal-subtitle {
  padding: 12px 0 0;
  margin: 0;
  display: block;
  width: 100%;
  align-self: stretch;
  font-size: 14px;
  color: #595959;
  text-align: left;
}

.shvev-modal-body {
  padding: 20px 28px;
  flex: 1;
  width: 100%;
  text-align: left;
}

.shvev-modal-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #161616;
  margin: 0 0 12px 0;
}

.shvev-modal-checkbox-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #595959;
  cursor: pointer;
  margin-bottom: 6px;
}

.shvev-modal-checkbox-row input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #0f62fe;
  flex-shrink: 0;
}

.shvev-modal-select-all {
  margin-bottom: 16px;
}

.shvev-modal-years-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 32px;
}

.shvev-modal-years-col {
  display: flex;
  flex-direction: column;
}

.shvev-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 28px 24px 28px;
  border-top: 1px solid #e8e8e8;
}

.shvev-modal-btn {
  height: 40px;
  padding: 0 24px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.shvev-modal-btn-cancel {
  background: #ffffff;
  border: 1px solid #0f62fe;
  color: #0f62fe;
}

.shvev-modal-btn-cancel:hover {
  background: #edf4ff;
}

.shvev-modal-btn-download {
  background: #0f62fe;
  border: 1px solid #0f62fe;
  color: #ffffff;
}

.shvev-modal-btn-download:hover:not(:disabled) {
  background: #0353e9;
  border-color: #0353e9;
}

.shvev-modal-btn-download:disabled {
  background: #c6c6c6;
  border-color: #c6c6c6;
  color: #ffffff;
  cursor: not-allowed;
}

/* ── Service-history detail drawer ── */
.shvev-service-link-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left !important;
  justify-content: flex-start !important;
  font-size: 14px !important;
}

.shvev-table td button.shvev-service-link-btn {
  justify-content: flex-start !important;
  text-align: left !important;
  width: 100% !important;
  padding: 0 !important;
}

.shvev-drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 900;
}

.shvev-drawer {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 360px;
  background: #ffffff;
  z-index: 901;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
}

.shvev-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.shvev-drawer-title {
  font-size: 16px;
  font-weight: 600;
  color: #161616;
  margin: 0;
}

.shvev-drawer-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #595959;
  padding: 4px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shvev-drawer-close:hover {
  color: #161616;
}

.shvev-drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 0 20px;
}

.shvev-drawer-row {
  padding: 14px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.shvev-drawer-label {
  font-size: 16px;
  font-weight: 600;
  color: #161616;
}

.shvev-drawer-value {
  font-size: 15px;
  color: #595959;
}

.shvev-drawer-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 0;
}

.shvev-drawer-footer {
  padding: 16px 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.shvev-drawer-close-btn {
  height: 36px;
  padding: 0 24px;
  border: 1.5px solid #0f62fe;
  border-radius: 999px;
  background: #ffffff;
  color: #0f62fe;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.shvev-drawer-close-btn:hover {
  background: #e8f0fe;
}
.serviceCard {
  .Card {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: -12px -12px;
    background-repeat: no-repeat;
    background-size: 385% auto;
  }

  .Card__content {
    gap: 24px !important;
    padding: 24px !important;
  }

  footer {
    margin-top: auto !important;
  }

  .serviceCardBody {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: calc(100% + 2px);
    color: var(--color-text-default, #001025);
  }
}

.serviceCardBodyPrimary {
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: var(--color-text-default, #001025);
}

.serviceCardBodySecondary {
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-text-default, #001025);
}

.serviceCardCta {
  padding-inline: 8px !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--color-text-primary-strong, #0564D7) !important;
}

.serviceCardCta svg,
.serviceCardCta [class*="Icon"] {
  width: 15.33px;
  height: 15.33px;
  color: var(--color-icon-primary, #066FEF);
}

.service-booking-widget-preview {
  display: flex;
  width: 392px;
  height: 392px;
  min-width: 392px;
  flex-direction: column;
  align-items: flex-start;
}

/* ── Mobile accordion card list (hidden on desktop) ── */
.shvev-mobile-list {
  display: none;
}

@media (max-width: 768px) {
  /* Hide the desktop table on mobile */
  .shvev-table-shell {
    display: none;
  }

  /* Show the mobile card list */
  .shvev-mobile-list {
    display: block;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #ffffff;
    overflow: hidden;
  }

  /* Header row — "Service History" select-all */
  .shvev-mobile-list-header {
    padding: 12px 16px;
    background: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
  }

  /* Individual item card */
  .shvev-mobile-item {
    border-bottom: 1px solid #e0e0e0;
  }

  .shvev-mobile-item:last-child {
    border-bottom: none;
  }

  /* Collapsed item header row */
  .shvev-mobile-item-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #ffffff;
  }

  /* Slightly tinted background when expanded */
  .shvev-mobile-item--expanded > .shvev-mobile-item-header {
    background: #f5f5f5;
  }

  /* Ensure individual row checkbox wrappers are sized to the checkbox only */
  .shvev-mobile-checkbox-wrap {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  /* Service no + source text area */
  .shvev-mobile-item-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .shvev-mobile-service-no {
    color: #0559bf !important;
    font-weight: 500 !important;
    font-size: 15px !important;
    line-height: 1.3 !important;
    padding: 0 !important;
    min-height: unset !important;
    text-align: left !important;
    justify-content: flex-start !important;
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    text-decoration: none;
    white-space: normal;
    word-break: break-word;
  }

  .shvev-mobile-service-no:hover,
  .shvev-mobile-service-no:focus-visible {
    text-decoration: underline !important;
    background: none !important;
    box-shadow: none !important;
  }

  .shvev-mobile-source {
    font-size: 13px;
    color: #595959;
    line-height: 1.3;
  }

  /* Expand + kebab action buttons */
  .shvev-mobile-item-actions {
    display: flex;
    align-items: center;
    gap: 0;
    flex-shrink: 0;
  }

  .shvev-mobile-expand-btn,
  .shvev-mobile-kebab-btn {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #595959 !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 6px !important;
    min-height: unset !important;
    min-width: unset !important;
  }

  .shvev-mobile-expand-btn:hover,
  .shvev-mobile-kebab-btn:hover {
    background: #f0f0f0 !important;
    border-radius: 4px !important;
    box-shadow: none !important;
  }

  /* Expanded detail body */
  .shvev-mobile-item-body {
    padding: 0 16px 4px;
    background: #ffffff;
  }

  .shvev-mobile-detail-row {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .shvev-mobile-detail-row:last-child {
    border-bottom: none;
  }

  .shvev-mobile-detail-label {
    font-size: 14px;
    font-weight: 600;
    color: #161616;
    line-height: 1.3;
  }

  .shvev-mobile-detail-value {
    font-size: 14px;
    color: #595959;
    line-height: 1.3;
  }

  /* Pagination adjustments for mobile card list */
  .shvev-mobile-list .shvev-pagination {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

/* ── Fleet view mobile accordion card list (hidden on desktop) ── */
.shfleet-mobile-list {
  display: none;
}

@media (max-width: 768px) {
  .shfleet-mobile-list {
    display: block;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #ffffff;
    overflow: hidden;
  }

  .shfleet-mobile-list-header {
    padding: 12px 16px;
    background: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
  }

  .shfleet-mobile-item {
    border-bottom: 1px solid #e0e0e0;
  }

  .shfleet-mobile-item:last-child {
    border-bottom: none;
  }

  .shfleet-mobile-item-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #ffffff;
  }

  .shfleet-mobile-item--expanded > .shfleet-mobile-item-header {
    background: #f5f5f5;
  }

  .shfleet-mobile-checkbox-wrap {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  .shfleet-mobile-item-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .shfleet-mobile-vehicle-row {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
  }

  .shfleet-mobile-vehicle-name {
    font-size: 15px !important;
    font-weight: 500 !important;
    color: #0559bf !important;
    line-height: 1.3 !important;
    text-decoration: none;
  }

  span.shfleet-mobile-vehicle-name {
    color: #161616 !important;
  }

  .shfleet-mobile-vehicle-name:hover,
  .shfleet-mobile-vehicle-name:focus-visible {
    text-decoration: underline !important;
  }

  .shfleet-mobile-vin {
    font-size: 13px;
    color: #595959;
    line-height: 1.3;
  }

  .shfleet-mobile-item-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .shfleet-mobile-item-body {
    padding: 0 16px 4px;
    background: #ffffff;
  }

  .shfleet-mobile-list .shvev-pagination {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;;EAEpB,0BAA0B;EAC1B,2EAA2E;EAC3E,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yDAA6T;EAC7T,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yDAAyL;EACzL,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,8DAA8D;AAChE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;EAC3C,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;EAC3B,UAAU;EACV,eAAe;EACf,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;EACtC,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;;EAIE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yDAAyL;EACzL,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;AACF;;AAEA,6CAA6C;AAC7C;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC;IACE,SAAS;EACX;;EAEA,mCAAmC;EACnC;IACE,OAAO;IACP,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,wBAAwB;EACxB;IACE,WAAW;EACb;;EAEA,6EAA6E;EAC7E;IACE,wBAAwB;EAC1B;;EAEA,+CAA+C;EAC/C;IACE,+BAA+B;IAC/B,WAAW;IACX,uBAAuB;IACvB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,2BAA2B;EAC3B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,yDAAuE;IACvE,gCAAgC;IAChC,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,yCAAyC;EAC3C;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC;IACE,aAAa;EACf;;EAEA,8BAA8B;EAC9B;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,8CAA8C;EAC9C;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;EACrB;;EAEA,yBAAyB;EACzB;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,6CAA6C;EAC7C;IACE,mBAAmB;EACrB;;EAEA,2EAA2E;EAC3E;IACE,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,sCAAsC;IACtC,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;;IAEE,qCAAqC;IACrC,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,kCAAkC;EAClC;IACE,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,cAAc;EAChB;;EAEA;;IAEE,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,yBAAyB;IACzB,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;;IAEE,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA,yBAAyB;EACzB;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,gDAAgD;EAChD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA,oEAAoE;AACpE;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF","sourcesContent":[":root {\n  --bg-top: #f8fafc;\n  --bg-bottom: #e4ebf5;\n  --table-border: #b2b2b2;\n  --header-bg: #f0f0f0;\n  --row-even: #fafafa;\n  --row-odd: #ffffff;\n  --text-default: #4d4d4d;\n  --link-blue: #0559bf;\n\n  color: var(--text-default);\n  font-family: 'Avenir Next', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: 400;\n  font-synthesis: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Null/empty cell dash indicator — scoped to avoid UCL conflicts */\n.shvev-null-dash {\n  font-size: 1.2em;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody,\nbutton,\ninput,\ntextarea,\nselect {\n  font: inherit;\n}\n\n.app-components {\n  padding: 20px;\n}\n\n.component-section {\n  margin-bottom: 32px;\n}\n\n.analysis-shell {\n  width: min(760px, calc(100% - 2.5rem));\n  margin: 0 auto;\n  padding: 3.25rem 0;\n}\n\n.analysis-table-card {\n  border: 1px solid var(--table-border);\n  border-radius: 8px;\n  overflow-x: auto;\n  background: #ffffff;\n  box-shadow: 0 10px 30px rgba(12, 25, 43, 0.1);\n}\n\n.analysis-table {\n  width: 100%;\n  min-width: 660px;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.analysis-table th,\n.analysis-table td {\n  height: 40px;\n  padding: 4px 12px;\n  border-bottom: 1px solid var(--table-border);\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  color: var(--text-default);\n}\n\n.analysis-table thead th {\n  background: var(--header-bg);\n  font-weight: 500;\n}\n\n.analysis-table tbody tr:nth-child(odd) td {\n  background: var(--row-odd);\n}\n\n.analysis-table tbody tr:nth-child(even) td {\n  background: var(--row-even);\n}\n\n.analysis-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.analysis-table a {\n  color: var(--link-blue);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.analysis-table a:hover,\n.analysis-table a:focus-visible {\n  text-decoration: underline;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@media (max-width: 760px) {\n  .analysis-shell {\n    width: min(100% - 1rem, 760px);\n    padding: 1rem 0 1.5rem;\n  }\n\n  .analysis-table-card {\n    border: 0;\n    box-shadow: none;\n    background: transparent;\n    overflow: visible;\n  }\n\n  .analysis-table {\n    min-width: 100%;\n    border-spacing: 0 0.75rem;\n  }\n\n  .analysis-table thead {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  .analysis-table tbody tr {\n    display: block;\n    border: 1px solid var(--table-border);\n    border-radius: 8px;\n    overflow: hidden;\n    background: #ffffff;\n  }\n\n  .analysis-table tbody td {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n    width: 100%;\n    height: auto;\n    border-bottom: 1px solid #dddddd;\n    padding: 0.7rem 0.9rem;\n    background: #ffffff;\n  }\n\n  .analysis-table tbody td:last-child {\n    border-bottom: 0;\n  }\n\n  .analysis-table tbody td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #404040;\n  }\n}\n\n.shvtv-root {\n  padding-top: 14px;\n  padding-bottom: 10px;\n  background: #ececec;\n}\n\n.shvtv-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.shvtv-title {\n  margin: 0;\n  color: #161616;\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 600;\n  letter-spacing: 0;\n  white-space: nowrap;\n}\n\n.shvtv-header a {\n  display: inline-flex;\n  align-items: center;\n  margin-left: auto;\n  color: #0559bf;\n  font-size: 19px;\n  line-height: 1;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.shvtv-header a:hover,\n.shvtv-header a:focus-visible {\n  text-decoration: underline;\n}\n\n.shvtv-table-shell {\n  border: 1px solid #b2b2b2;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.shvtv-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.shvtv-head-cell {\n  padding: 12px 10px;\n  background: #fafafb !important;\n  border-bottom: 1px solid #e0e0e0;\n  color: #4f4f4f;\n  text-align: left;\n  font-size: 16px;\n  line-height: 1.2;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.shvtv-body-cell {\n  padding: 10px;\n  color: #595959;\n  font-size: 15px;\n  line-height: 1.25;\n  font-weight: 400;\n}\n\n.shvtv-row-even {\n  background: #ececec !important;\n}\n\n.shvtv-row-odd {\n  background: #f6f6f6 !important;\n}\n\n.shvtv-service-link-cell a {\n  color: #0559bf;\n  text-decoration: none;\n  font-size: 15px;\n  line-height: 1.25;\n  font-weight: 500;\n}\n\n.shvtv-service-link-cell a:hover,\n.shvtv-service-link-cell a:focus-visible {\n  text-decoration: underline;\n}\n\n@media (max-width: 760px) {\n  .shvtv-root {\n    max-width: 100%;\n    padding: 10px;\n  }\n\n  .shvtv-title {\n    font-size: 24px;\n  }\n\n  .shvtv-header a {\n    font-size: 20px;\n  }\n\n  .shvtv-head-cell,\n  .shvtv-body-cell,\n  .shvtv-service-link-cell a {\n    font-size: 16px;\n    line-height: 1.35;\n  }\n\n  .shvtv-head-cell,\n  .shvtv-body-cell {\n    padding: 10px 8px;\n  }\n}\n\n.shvev-root {\n  padding: 0;\n  background: #ffffff;\n  color: #595959;\n}\n\n.shvev-title {\n  margin: 0 0 16px;\n  color: #161616;\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 600;\n}\n\n.shvev-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.shvev-fleet-alert {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border-radius: 10px;\n  background: #eaf4ff;\n  color: #0559bf;\n  padding: 12px 16px;\n  font-size: 15px;\n  line-height: 1.4;\n}\n\n.shvev-fleet-alert-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #0559bf;\n  flex-shrink: 0;\n}\n\n.shvev-controls-top {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  justify-content: space-between;\n}\n\n.shvev-controls-top--left {\n  justify-content: flex-start;\n}\n\n.shvev-control-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.shvev-control-search {\n  flex: 0 1 360px;\n  min-width: 260px;\n  max-width: none;\n}\n\n.shvev-control-category {\n  width: fit-content;\n  min-width: 150px;\n}\n\n.shvev-category-dropdown {\n  position: relative;\n}\n\n.shvev-category-trigger {\n  min-height: 32px;\n  border-radius: 8px !important;\n  border: 1px solid #767676 !important;\n  padding: 4px 10px !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  cursor: pointer !important;\n}\n\n.shvev-category-trigger.shvev-category-trigger {\n  color: #595959;\n}\n\n.shvev-category-label {\n  color: #595959;\n}\n\n.shvev-category-trigger:focus {\n  outline: none;\n  border-color: #0f62fe;\n  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);\n}\n\n.shvev-category-count {\n  min-width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  background: #0f62fe;\n  color: #ffffff;\n  font-size: 11px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n}\n\n.shvev-category-chevron {\n  display: inline-flex;\n  align-items: center;\n  color: #0f62fe;\n  transition: transform 0.15s ease;\n}\n\n.shvev-category-chevron.open {\n  transform: rotate(180deg);\n}\n\n.shvev-category-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  width: 260px;\n  border: 1px solid #c6c6c6;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14);\n  z-index: 50;\n}\n\n.shvev-category-search-wrap {\n  padding: 10px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.shvev-category-search {\n  width: 100%;\n  height: 36px;\n  border: 1px solid #c6c6c6;\n  border-radius: 8px;\n  padding: 0 10px;\n  font-size: 13px;\n  color: #3d3d3d;\n}\n\n.shvev-category-search:focus {\n  outline: none;\n  border-color: #0f62fe;\n  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);\n}\n\n.shvev-category-options {\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 8px 10px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.shvev-category-option input[type='checkbox'] {\n  width: 18px;\n  height: 18px;\n  margin-top: 1px;\n  accent-color: #0f62fe;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.shvev-category-no-results {\n  margin: 12px 0;\n  text-align: center;\n  color: #525252;\n  font-size: 15px;\n}\n\n.shvev-clear-input-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: #6f6f6f;\n  cursor: pointer;\n  padding: 0;\n}\n\n.shvev-clear-input-btn:hover {\n  background: #eef2f7;\n  color: #3d3d3d;\n}\n\n.shvev-clear-input-btn:focus-visible {\n  outline: 2px solid #0f62fe;\n  outline-offset: 1px;\n}\n\n.shvev-control-label {\n  font-size: 13px;\n  line-height: 1.2;\n  font-weight: 500;\n  color: #595959;\n}\n\n.shvev-search-wrapper {\n  position: relative;\n}\n\n.shvev-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Ccircle cx='7' cy='7' r='5' fill='none' stroke='%238d8d8d' stroke-width='1.5'/%3E%3Cpath d='M10.8 10.8L14 14' stroke='%238d8d8d' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  pointer-events: none;\n}\n\n.shvev-select,\n.shvev-search {\n  height: 32px;\n  border: 1px solid #b8b8b8;\n  border-radius: 8px;\n  padding: 0 10px;\n  background: #ffffff;\n  font-size: 15px;\n  line-height: 1.25;\n  color: #595959;\n}\n\n.shvev-search {\n  width: 100%;\n  padding-left: 36px;\n}\n\n.shvev-select {\n  min-width: 130px;\n  padding-right: 28px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23525252'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n}\n\n.shvev-select:focus,\n.shvev-search:focus {\n  outline: none;\n  border-color: #0f62fe;\n  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);\n}\n\n.shvev-download-btn,\n.shvev-download-btn:not([class*='Button']) {\n  height: 36px;\n  border: 1.5px solid #0f62fe;\n  border-radius: 8px !important;\n  background: #ffffff;\n  color: #0559bf;\n  padding: 0 20px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n  margin-left: auto;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.shvev-download-btn:hover {\n  background: #edf4ff;\n  border-color: #0559bf;\n}\n\n.shvev-download-btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.3);\n}\n\n.shvev-download-icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.shvev-download-btn-loading,\n.shvev-download-btn-loading:hover,\n.shvev-download-btn-loading:focus {\n  background-color: #8d8d8d !important;\n  border-color: #8d8d8d !important;\n  color: #ffffff !important;\n  cursor: not-allowed !important;\n}\n\n.shvev-snackbar-wrapper {\n  display: flex;\n  justify-content: center;\n  margin: 8px 0 4px;\n}\n\n/* Custom toast — matches @ucl/fpds Snackbar design tokens exactly */\n.shvev-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  gap: 8px;\n  padding-block: 8px;\n  padding-inline: 16px;\n  padding-inline-end: 8px;\n  border-radius: 8px;\n  margin-top: 16px;\n  min-height: 48px;\n  box-sizing: border-box;\n  color: #ffffff;\n  background-color: #001025;\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  letter-spacing: 0;\n  pointer-events: all;\n  flex-shrink: 0;\n  flex-grow: 0;\n  animation: shvev-toast-open 0.3s ease-in-out;\n}\n\n@keyframes shvev-toast-open {\n  from { opacity: 0; transform: translateY(100%); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.shvev-toast--success,\n.shvev-toast--primary {\n  background-color: #001025;\n}\n\n.shvev-toast--error {\n  background-color: #d62d0a;\n}\n\n.shvev-toast-message {\n  padding: 4px;\n  padding-inline-end: 12px;\n  box-sizing: border-box;\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n}\n\n.shvev-toast-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  padding: 2px 4px;\n  opacity: 0.8;\n  flex-shrink: 0;\n  height: 32px;\n  width: 32px;\n  border-radius: 8px;\n}\n\n.shvev-toast-close:hover {\n  opacity: 1;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n.shvev-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 72px;\n  width: 100%;\n}\n\n.shvev-service-link {\n  color: #0559bf;\n  font-size: 15px;\n  line-height: 1.25;\n  font-weight: 500;\n  display: inline-block;\n  text-decoration: none;\n}\n\n.shvev-service-link:hover,\n.shvev-service-link:focus-visible {\n  text-decoration: underline;\n}\n\n.shvev-vehicle-cell {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.shvev-vehicle-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #161616;\n  line-height: 1.3;\n}\n\n.shvev-vehicle-vin {\n  font-size: 13px;\n  color: #6f6f6f;\n  line-height: 1.3;\n}\n\na.shvev-vehicle-vin {\n  color: #0559bf;\n  text-decoration: none;\n}\n\na.shvev-vehicle-vin:hover,\na.shvev-vehicle-vin:focus-visible {\n  text-decoration: underline;\n}\n\n.shvev-vehicle-vin-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.shvev-redirect-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  color: #0559bf;\n  padding: 0;\n  cursor: pointer;\n}\n\n.shvev-redirect-icon-btn:hover {\n  color: #0559bf;\n}\n\n.shvev-redirect-icon-btn:focus-visible {\n  outline: 2px solid #0f62fe;\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\n.shvev-vin-subtext {\n  display: block;\n  margin-top: 4px;\n  color: #595959;\n  font-size: 12px;\n}\n\n.shvev-source-subtext {\n  display: block;\n  margin-top: 4px;\n  color: #595959;\n  font-size: 15px;\n  line-height: 1.25;\n  font-weight: 400;\n}\n\n.shvev-table-shell {\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  overflow: auto;\n  background: #ffffff;\n}\n\n.shvev-table {\n  width: 100%;\n  min-width: 1240px;\n  border-collapse: collapse;\n}\n\n.shvev-table th {\n  padding: 12px 16px;\n  text-align: left !important;\n  background: #fafafb !important;\n  border-bottom: 1px solid #e0e0e0;\n  color: #595959 !important;\n  font-size: 16px;\n  line-height: 1.2;\n  font-weight: 400 !important;\n}\n\n.shvev-table .TableHeader {\n  padding: 12px 16px !important;\n  background: #fafafb !important;\n  border-bottom: 1px solid #e0e0e0 !important;\n  color: #595959 !important;\n  font-size: 16px !important;\n  line-height: 1.2 !important;\n  font-weight: 400 !important;\n}\n\n.shvev-th-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background: transparent;\n  color: #595959 !important;\n  font: inherit;\n  font-size: 16px !important;\n  font-weight: 400 !important;\n  padding: 0;\n  cursor: pointer;\n  text-align: left !important;\n  justify-content: flex-start !important;\n}\n\n.shvev-table th button.shvev-th-button,\n.shvev-table .TableHeader button.shvev-th-button {\n  justify-content: flex-start !important;\n  text-align: left !important;\n  width: 100% !important;\n  padding: 0 !important;\n}\n\n.shvev-table th button.shvev-th-button:hover,\n.shvev-table th button.shvev-th-button:active,\n.shvev-table .TableHeader button.shvev-th-button:hover,\n.shvev-table .TableHeader button.shvev-th-button:active {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.shvev-th-button:focus-visible {\n  outline: 2px solid #0f62fe;\n  outline-offset: 2px;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.shvev-sort-icon {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1px;\n  color: #595959;\n  line-height: 1;\n}\n\n.shvev-sort-tri {\n  font-size: 10px;\n  line-height: 1;\n}\n\n.shvev-sort-icon--active {\n  display: inline-flex;\n  align-items: center;\n  color: #595959;\n  font-size: 11px;\n  line-height: 1;\n}\n\n\n.shvev-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e8e8e8;\n  color: #595959;\n  font-size: 15px;\n  line-height: 1.25;\n  font-weight: 400;\n  text-align: left !important;\n  vertical-align: top;\n}\n\n.shvev-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.shvev-table tbody tr:nth-child(odd) {\n  background: #ffffff;\n}\n\n.shvev-table tbody tr:nth-child(even) {\n  background: #f9f9f9;\n}\n\n.shvev-empty {\n  margin: 16px;\n  padding: 12px;\n  text-align: center;\n  color: #595959;\n  font-size: 15px;\n}\n\n.shvev-no-results {\n  margin: 24px 0 12px;\n  text-align: center;\n  color: #000000;\n  font-size: 20px;\n  line-height: 1.2;\n  font-weight: 700;\n}\n\n.shvev-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-top: 1px solid #e0e0e0;\n  background: #f9f9f9;\n  font-size: 13px;\n  gap: 16px;\n}\n\n.shvev-pagination-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n}\n\n.shvev-pagination-left .Pagination_TextWrapper {\n  display: none !important;\n}\n\n.shvev-pagination .Pagination_TextWrapper {\n  display: none !important;\n}\n\n.shvev-pagination [aria-live='polite'] {\n  display: none !important;\n}\n\n.shvev-pagination-left nav {\n  display: none;\n}\n\n.shvev-rows-per-page {\n  height: 32px;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  padding: 0 28px 0 10px;\n  background: #ffffff;\n  font-size: 13px;\n  color: #525252;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23525252'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n}\n\n.shvev-rows-per-page:focus {\n  outline: none;\n  border-color: #0f62fe;\n  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);\n}\n\n.shvev-pagination-total {\n  color: #595959;\n  white-space: nowrap;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 1.4;\n}\n\n.shvev-pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.shvev-pagination-btn {\n  height: 32px;\n  width: 32px;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: #0559bf;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.shvev-pagination-arrow {\n  font-size: 20px;\n  line-height: 1;\n}\n\n.shvev-pagination-btn:hover:not(:disabled) {\n  background: #dde8ff;\n}\n\n.shvev-pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  color: #a8a8a8;\n}\n\n.shvev-pagination-btn.active {\n  background: #0559bf;\n  color: #ffffff;\n}\n\n.shvev-pagination-btn.active:hover {\n  background: #0559bf;\n}\n\n.shvev-pagination-ellipsis {\n  color: #8d8d8d;\n  padding: 0 6px;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .shvev-pagination {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .shvev-pagination-left,\n  .shvev-pagination-controls {\n    width: 100%;\n  }\n\n  .shvev-pagination-controls {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n}\n\n/* Mobile download button hidden on desktop */\n.shvev-download-btn--mobile {\n  display: none !important;\n}\n\n@media (max-width: 768px) {\n  /* Uniform gap between controls */\n  .shvev-controls {\n    gap: 12px;\n  }\n\n  /* Search stretches to full width */\n  .shvev-control-search {\n    flex: 1;\n    min-width: unset;\n    max-width: unset;\n  }\n\n  /* Category full width */\n  .shvev-control-category {\n    width: 100%;\n  }\n\n  /* Hide the desktop download button (inside controls-top) — fleet view only */\n  .shvev-controls-top:not(.shvev-controls-top--left) .shvev-download-btn {\n    display: none !important;\n  }\n\n  /* Show and expand the mobile download button */\n  .shvev-download-btn--mobile {\n    display: inline-flex !important;\n    width: 100%;\n    justify-content: center;\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 1100px) {\n  .shvev-controls-top {\n    align-items: center;\n  }\n\n  .shvev-control-search {\n    flex: 0 1 320px;\n    min-width: 240px;\n  }\n\n  .shvev-download-btn {\n    width: auto;\n  }\n}\n\n/* Export modal */\n.shvev-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.shvev-modal {\n  background: #ffffff;\n  border-radius: 12px;\n  width: 640px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 64px);\n  overflow-y: auto;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n  display: flex;\n  flex-direction: column;\n}\n\n.shvev-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 28px 28px 0 28px;\n}\n\n.shvev-modal-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #161616;\n  margin: 0;\n}\n\n.shvev-modal-close {\n  border: none;\n  background: transparent;\n  font-size: 18px;\n  color: #595959;\n  cursor: pointer;\n  padding: 4px 8px;\n  line-height: 1;\n  border-radius: 4px;\n}\n\n.shvev-modal-close:hover {\n  background: #f4f4f4;\n  color: #161616;\n}\n\n.shvev-modal-subtitle {\n  padding: 12px 0 0;\n  margin: 0;\n  display: block;\n  width: 100%;\n  align-self: stretch;\n  font-size: 14px;\n  color: #595959;\n  text-align: left;\n}\n\n.shvev-modal-body {\n  padding: 20px 28px;\n  flex: 1;\n  width: 100%;\n  text-align: left;\n}\n\n.shvev-modal-section-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #161616;\n  margin: 0 0 12px 0;\n}\n\n.shvev-modal-checkbox-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #595959;\n  cursor: pointer;\n  margin-bottom: 6px;\n}\n\n.shvev-modal-checkbox-row input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #0f62fe;\n  flex-shrink: 0;\n}\n\n.shvev-modal-select-all {\n  margin-bottom: 16px;\n}\n\n.shvev-modal-years-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 32px;\n}\n\n.shvev-modal-years-col {\n  display: flex;\n  flex-direction: column;\n}\n\n.shvev-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 28px 24px 28px;\n  border-top: 1px solid #e8e8e8;\n}\n\n.shvev-modal-btn {\n  height: 40px;\n  padding: 0 24px;\n  border-radius: 24px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.shvev-modal-btn-cancel {\n  background: #ffffff;\n  border: 1px solid #0f62fe;\n  color: #0f62fe;\n}\n\n.shvev-modal-btn-cancel:hover {\n  background: #edf4ff;\n}\n\n.shvev-modal-btn-download {\n  background: #0f62fe;\n  border: 1px solid #0f62fe;\n  color: #ffffff;\n}\n\n.shvev-modal-btn-download:hover:not(:disabled) {\n  background: #0353e9;\n  border-color: #0353e9;\n}\n\n.shvev-modal-btn-download:disabled {\n  background: #c6c6c6;\n  border-color: #c6c6c6;\n  color: #ffffff;\n  cursor: not-allowed;\n}\n\n/* ── Service-history detail drawer ── */\n.shvev-service-link-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  text-align: left !important;\n  justify-content: flex-start !important;\n  font-size: 14px !important;\n}\n\n.shvev-table td button.shvev-service-link-btn {\n  justify-content: flex-start !important;\n  text-align: left !important;\n  width: 100% !important;\n  padding: 0 !important;\n}\n\n.shvev-drawer-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 900;\n}\n\n.shvev-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 360px;\n  background: #ffffff;\n  z-index: 901;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n}\n\n.shvev-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 20px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  flex-shrink: 0;\n}\n\n.shvev-drawer-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #161616;\n  margin: 0;\n}\n\n.shvev-drawer-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  color: #595959;\n  padding: 4px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.shvev-drawer-close:hover {\n  color: #161616;\n}\n\n.shvev-drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 20px;\n}\n\n.shvev-drawer-row {\n  padding: 14px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.shvev-drawer-label {\n  font-size: 16px;\n  font-weight: 600;\n  color: #161616;\n}\n\n.shvev-drawer-value {\n  font-size: 15px;\n  color: #595959;\n}\n\n.shvev-drawer-divider {\n  height: 1px;\n  background: #e0e0e0;\n  margin: 0;\n}\n\n.shvev-drawer-footer {\n  padding: 16px 20px;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.shvev-drawer-close-btn {\n  height: 36px;\n  padding: 0 24px;\n  border: 1.5px solid #0f62fe;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #0f62fe;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.shvev-drawer-close-btn:hover {\n  background: #e8f0fe;\n}\n.serviceCard {\n  .Card {\n    background-image: url(\"./assets/service-booking-widget-background.png\");\n    background-position: -12px -12px;\n    background-repeat: no-repeat;\n    background-size: 385% auto;\n  }\n\n  .Card__content {\n    gap: 24px !important;\n    padding: 24px !important;\n  }\n\n  footer {\n    margin-top: auto !important;\n  }\n\n  .serviceCardBody {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: calc(100% + 2px);\n    color: var(--color-text-default, #001025);\n  }\n}\n\n.serviceCardBodyPrimary {\n  margin: 0;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--color-text-default, #001025);\n}\n\n.serviceCardBodySecondary {\n  margin: 0;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--color-text-default, #001025);\n}\n\n.serviceCardCta {\n  padding-inline: 8px !important;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  color: var(--color-text-primary-strong, #0564D7) !important;\n}\n\n.serviceCardCta svg,\n.serviceCardCta [class*=\"Icon\"] {\n  width: 15.33px;\n  height: 15.33px;\n  color: var(--color-icon-primary, #066FEF);\n}\n\n.service-booking-widget-preview {\n  display: flex;\n  width: 392px;\n  height: 392px;\n  min-width: 392px;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n/* ── Mobile accordion card list (hidden on desktop) ── */\n.shvev-mobile-list {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  /* Hide the desktop table on mobile */\n  .shvev-table-shell {\n    display: none;\n  }\n\n  /* Show the mobile card list */\n  .shvev-mobile-list {\n    display: block;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    background: #ffffff;\n    overflow: hidden;\n  }\n\n  /* Header row — \"Service History\" select-all */\n  .shvev-mobile-list-header {\n    padding: 12px 16px;\n    background: #ffffff;\n    border-bottom: 1px solid #e0e0e0;\n    display: flex;\n    align-items: center;\n  }\n\n  /* Individual item card */\n  .shvev-mobile-item {\n    border-bottom: 1px solid #e0e0e0;\n  }\n\n  .shvev-mobile-item:last-child {\n    border-bottom: none;\n  }\n\n  /* Collapsed item header row */\n  .shvev-mobile-item-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    background: #ffffff;\n  }\n\n  /* Slightly tinted background when expanded */\n  .shvev-mobile-item--expanded > .shvev-mobile-item-header {\n    background: #f5f5f5;\n  }\n\n  /* Ensure individual row checkbox wrappers are sized to the checkbox only */\n  .shvev-mobile-checkbox-wrap {\n    display: inline-flex;\n    align-items: center;\n    flex-shrink: 0;\n  }\n\n  /* Service no + source text area */\n  .shvev-mobile-item-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  .shvev-mobile-service-no {\n    color: #0559bf !important;\n    font-weight: 500 !important;\n    font-size: 15px !important;\n    line-height: 1.3 !important;\n    padding: 0 !important;\n    min-height: unset !important;\n    text-align: left !important;\n    justify-content: flex-start !important;\n    background: none !important;\n    border: none !important;\n    box-shadow: none !important;\n    text-decoration: none;\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  .shvev-mobile-service-no:hover,\n  .shvev-mobile-service-no:focus-visible {\n    text-decoration: underline !important;\n    background: none !important;\n    box-shadow: none !important;\n  }\n\n  .shvev-mobile-source {\n    font-size: 13px;\n    color: #595959;\n    line-height: 1.3;\n  }\n\n  /* Expand + kebab action buttons */\n  .shvev-mobile-item-actions {\n    display: flex;\n    align-items: center;\n    gap: 0;\n    flex-shrink: 0;\n  }\n\n  .shvev-mobile-expand-btn,\n  .shvev-mobile-kebab-btn {\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    color: #595959 !important;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 6px !important;\n    min-height: unset !important;\n    min-width: unset !important;\n  }\n\n  .shvev-mobile-expand-btn:hover,\n  .shvev-mobile-kebab-btn:hover {\n    background: #f0f0f0 !important;\n    border-radius: 4px !important;\n    box-shadow: none !important;\n  }\n\n  /* Expanded detail body */\n  .shvev-mobile-item-body {\n    padding: 0 16px 4px;\n    background: #ffffff;\n  }\n\n  .shvev-mobile-detail-row {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    padding: 10px 0;\n    border-bottom: 1px solid #f0f0f0;\n  }\n\n  .shvev-mobile-detail-row:last-child {\n    border-bottom: none;\n  }\n\n  .shvev-mobile-detail-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #161616;\n    line-height: 1.3;\n  }\n\n  .shvev-mobile-detail-value {\n    font-size: 14px;\n    color: #595959;\n    line-height: 1.3;\n  }\n\n  /* Pagination adjustments for mobile card list */\n  .shvev-mobile-list .shvev-pagination {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n/* ── Fleet view mobile accordion card list (hidden on desktop) ── */\n.shfleet-mobile-list {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .shfleet-mobile-list {\n    display: block;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    background: #ffffff;\n    overflow: hidden;\n  }\n\n  .shfleet-mobile-list-header {\n    padding: 12px 16px;\n    background: #ffffff;\n    border-bottom: 1px solid #e0e0e0;\n    display: flex;\n    align-items: center;\n  }\n\n  .shfleet-mobile-item {\n    border-bottom: 1px solid #e0e0e0;\n  }\n\n  .shfleet-mobile-item:last-child {\n    border-bottom: none;\n  }\n\n  .shfleet-mobile-item-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    background: #ffffff;\n  }\n\n  .shfleet-mobile-item--expanded > .shfleet-mobile-item-header {\n    background: #f5f5f5;\n  }\n\n  .shfleet-mobile-checkbox-wrap {\n    display: inline-flex;\n    align-items: center;\n    flex-shrink: 0;\n  }\n\n  .shfleet-mobile-item-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  .shfleet-mobile-vehicle-row {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    flex-wrap: wrap;\n  }\n\n  .shfleet-mobile-vehicle-name {\n    font-size: 15px !important;\n    font-weight: 500 !important;\n    color: #0559bf !important;\n    line-height: 1.3 !important;\n    text-decoration: none;\n  }\n\n  span.shfleet-mobile-vehicle-name {\n    color: #161616 !important;\n  }\n\n  .shfleet-mobile-vehicle-name:hover,\n  .shfleet-mobile-vehicle-name:focus-visible {\n    text-decoration: underline !important;\n  }\n\n  .shfleet-mobile-vin {\n    font-size: 13px;\n    color: #595959;\n    line-height: 1.3;\n  }\n\n  .shfleet-mobile-item-actions {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n  }\n\n  .shfleet-mobile-item-body {\n    padding: 0 16px 4px;\n    background: #ffffff;\n  }\n\n  .shfleet-mobile-list .shvev-pagination {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
